import makeLang from 'ck-core/source/functions/makeLang';

export default makeLang({
	MONTHS: [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	]
});
